<main class="gestor" [class.gestor--simulador]="modoSimulador">
  <header class="gestor__topo">
    <div class="gestor__marca">
      <span class="gestor__sinal" aria-hidden="true"></span>
      <span>MIA / GESTOR</span>
    </div>

    <div class="gestor__status"
         [class.gestor__status--online]="conectado"
         [class.gestor__status--verificando]="verificando">
      <span class="gestor__status-ponto" aria-hidden="true"></span>
      {{ verificando ? 'Verificando serviço' : conectado ? 'Agente conectado' : 'Agente indisponível' }}
      <button *ngIf="!verificando && !conectado"
              type="button"
              class="gestor__tentar"
              (click)="verifiqueConexao()">
        Tentar novamente
      </button>
    </div>

    <button type="button" class="gestor__modo" (click)="alterneSimulador()">
      <i class="fas" [class.fa-flask]="!modoSimulador" [class.fa-columns]="modoSimulador" aria-hidden="true"></i>
      {{ modoSimulador ? 'Voltar ao painel' : 'Abrir simulador' }}
    </button>
  </header>

  <section class="gestor__abertura">
    <div>
      <span class="gestor__etiqueta">{{ modoSimulador ? 'SIMULADOR CONVERSACIONAL' : 'ETAPAS 4 E 5 · CARDÁPIO' }}</span>
      <h1 *ngIf="!modoSimulador">Do documento para<br><em>um catálogo revisado.</em></h1>
      <h1 *ngIf="modoSimulador">Converse com o Gestor<br><em>antes de aprovar.</em></h1>
    </div>
    <p>
      {{ modoSimulador
        ? 'O simulador usa o mesmo agente e o mesmo onboarding persistido. Mensagens testam a conversa; ações reais continuam protegidas por preview e botão separado.'
        : 'Envie PDF ou fotos, revise o rascunho extraído e escolha o que entra no catálogo. Nenhum produto é criado antes da aprovação explícita.' }}
    </p>
  </section>

  <ol class="gestor__marcos" aria-label="Etapas da implantação">
    <li *ngFor="let marco of marcos"
        class="marco"
        [class.marco--ativo]="marco.estado === 'ativo'"
        [class.marco--concluido]="marco.estado === 'concluido'"
        [class.marco--erro]="marco.estado === 'erro'">
      <span class="marco__numero">{{ marco.numero }}</span>
      <span class="marco__conteudo">
        <strong>{{ marco.titulo }}</strong>
        <small>{{ marco.detalhe }}</small>
      </span>
      <i class="fas"
         [class.fa-circle-notch]="marco.estado === 'ativo'"
         [class.fa-check]="marco.estado === 'concluido'"
         [class.fa-exclamation-triangle]="marco.estado === 'erro'"
         [class.fa-lock]="marco.estado === 'bloqueado'"
         aria-hidden="true"></i>
    </li>
  </ol>

  <section class="gestor__mesa">
    <aside class="gestor__mapa">
        <span class="gestor__mapa-indice">{{ modoSimulador ? 'LAB' : '05' }}</span>
      <div>
        <span class="gestor__etiqueta">ESTADO OFICIAL</span>
        <h2>{{ carregandoOnboarding ? 'Retomando processo' : modoSimulador ? 'Ambiente de conversa' : empresaId ? 'Tenant fixado' : 'Abertura assistida' }}</h2>
        <p>
          Informe apenas o nome da empresa. A MIA cria e valida o endereço do
          cardápio e apresenta tudo pronto para sua aprovação.
        </p>
      </div>

      <div class="simulador__roteiros" *ngIf="modoSimulador">
        <span class="gestor__etiqueta">ROTEIROS RÁPIDOS</span>
        <button type="button" (click)="usePerguntaSimulador('O que falta para concluir meu onboarding?')">
          Consultar progresso
        </button>
        <button type="button" (click)="usePerguntaSimulador('Já enviei meu cardápio. O que você consegue analisar?')">
          Testar análise
        </button>
        <button type="button" (click)="usePerguntaSimulador('Quais produtos estão prontos e quais têm pendências?')">
          Revisar rascunho
        </button>
        <button type="button" (click)="usePerguntaSimulador('Prepare a importação apenas dos produtos selecionados.')">
          Testar proposta
        </button>
        <small>Os botões acima apenas preenchem a conversa. Eles não aprovam nem importam.</small>
      </div>

      <dl class="gestor__registro" *ngIf="onboardingId">
        <div><dt>Onboarding</dt><dd>#{{ onboardingId }}</dd></div>
        <div><dt>Etapa</dt><dd>{{ etapaLegivel }}</dd></div>
        <div><dt>Versão</dt><dd>{{ versao }}</dd></div>
        <div><dt>Empresa</dt><dd>{{ empresaId ? '#' + empresaId : 'pré-tenant' }}</dd></div>
      </dl>

      <div class="gestor__fluxo" aria-label="Fluxo de segurança da ação">
        <span>ESTADO</span><i></i><span>PREVIEW</span><i></i><span>APROVAÇÃO</span>
      </div>

      <div class="gestor__limite">
        <i class="fas fa-shield-alt" aria-hidden="true"></i>
        <span>
          <strong>Mensagem não é aprovação</strong>
          Toda ação de risco exige preview persistido e um botão separado.
        </span>
      </div>
    </aside>

    <article class="conversa" [class.conversa--simulador]="modoSimulador">
      <header class="conversa__topo">
        <div>
          <span class="conversa__avatar">MG</span>
          <span>
            <strong>MIA Gestor</strong>
            <small>{{ carregandoOnboarding ? 'Retomando estado…' : etapaLegivel }}</small>
          </span>
        </div>
        <span class="conversa__id" *ngIf="onboardingId">
          ONBOARDING #{{ onboardingId }}<ng-container *ngIf="conversaId"> · CONVERSA #{{ conversaId }}</ng-container>
        </span>
      </header>

      <div class="gestor__aviso gestor__aviso--carregando" *ngIf="carregandoOnboarding">
        <i class="fas fa-circle-notch fa-spin" aria-hidden="true"></i>
        Buscando o último estado persistido…
      </div>

      <div class="gestor__aviso gestor__aviso--erro" *ngIf="erroOnboarding">
        <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
        <span>{{ erroOnboarding }}</span>
        <button *ngIf="!onboardingId" type="button" (click)="crieOuRetomeOnboarding()">Tentar novamente</button>
      </div>

      <div #listaMensagens class="conversa__mensagens" aria-live="polite">
        <div *ngFor="let item of mensagens"
             class="mensagem"
             [class.mensagem--usuario]="item.papel === 'usuario'"
             [class.mensagem--sistema]="item.papel === 'sistema'">
          <span class="mensagem__avatar" aria-hidden="true">
            <i *ngIf="item.papel === 'sistema'" class="fas fa-shield-alt"></i>
            <ng-container *ngIf="item.papel !== 'sistema'">
              {{ item.papel === 'usuario' ? 'EU' : 'M' }}
            </ng-container>
          </span>
          <div class="mensagem__conteudo">
            <span class="mensagem__autor">
              {{ item.papel === 'usuario' ? 'Você' : item.papel === 'gestor' ? 'MIA Gestor' : 'Sistema' }}
            </span>
            <div class="mensagem__balao">
              <p>
                <ng-container *ngFor="let trecho of partesDaMensagem(item.texto)">
                  <strong *ngIf="trecho.destaque">{{ trecho.texto }}</strong>
                  <ng-container *ngIf="!trecho.destaque">{{ trecho.texto }}</ng-container>
                </ng-container>
              </p>
              <span class="mensagem__ferramenta"
                    [class.mensagem__ferramenta--falhou]="!ferramenta.sucesso"
                    *ngFor="let ferramenta of item.ferramentas">
                <i class="fas" [class.fa-check-circle]="ferramenta.sucesso"
                   [class.fa-exclamation-circle]="!ferramenta.sucesso" aria-hidden="true"></i>
                {{ rotuloDaFerramenta(ferramenta.nome) }} · {{ ferramenta.sucesso ? 'concluído' : 'não concluído' }}
              </span>
            </div>
          </div>
        </div>

        <div class="mensagem mensagem--digitando" *ngIf="enviando">
          <span class="mensagem__avatar" aria-hidden="true">M</span>
          <div class="mensagem__conteudo">
            <span class="mensagem__autor">MIA Gestor</span>
            <div class="mensagem__balao mensagem__digitando-pontos">
              <span></span><span></span><span></span>
            </div>
          </div>
        </div>
      </div>

      <section class="empresa-criada" *ngIf="provisionamentoEmpresa">
        <header class="empresa-criada__cabecalho">
          <span>
            <small>EMPRESA CRIADA</small>
            <strong>{{ provisionamentoEmpresa.empresa.nome }}</strong>
          </span>
          <span class="empresa-criada__selo"
                [class.empresa-criada__selo--atencao]="dnsTemErro">
            {{ provisionamentoEmpresa.publicacao === 'CONFIGURADA' ? 'DNS configurado' :
               provisionamentoEmpresa.publicacao === 'NAO_APLICAVEL' ? 'DNS em produção' : 'DNS pendente' }}
          </span>
        </header>

        <dl class="empresa-criada__identidade">
          <div><dt>Empresa</dt><dd>#{{ provisionamentoEmpresa.empresa.id }}</dd></div>
          <div><dt>Catálogo</dt><dd>#{{ provisionamentoEmpresa.catalogo.id }}</dd></div>
          <div><dt>Subdomínio</dt><dd>{{ provisionamentoEmpresa.empresa.subdominio }}</dd></div>
          <div><dt>Responsável</dt><dd>{{ provisionamentoEmpresa.responsavel.nome }}</dd></div>
        </dl>

        <div class="empresa-criada__dns">
          <div *ngFor="let zona of provisionamentoEmpresa.dns"
               [class.empresa-criada__dns-item--erro]="zona.status === 'ERRO'">
            <span class="empresa-criada__dns-ponto" aria-hidden="true"></span>
            <span><strong>{{ zona.hostname }}</strong><small>{{ statusDnsLegivel(zona.status) }}</small></span>
          </div>
        </div>
        <p>O estado acima é o retorno persistido do provisionamento. Abrir e verificar o link público entra na Etapa 7.</p>
      </section>

      <section class="cardapio-lab" *ngIf="empresaId && (podeEnviarCardapio || analiseCardapio)">
        <header class="cardapio-lab__topo">
          <span>
            <small>ETAPAS 4 E 5</small>
            <strong>Importação assistida</strong>
          </span>
          <span class="cardapio-lab__estado" *ngIf="analiseCardapio">
            {{ analiseCardapio.status.replace('_', ' ') }} · V{{ analiseCardapio.versao }}
          </span>
        </header>

        <div class="cardapio-lab__envio" *ngIf="podeEnviarCardapio">
          <div>
            <strong>PDF ou fotos do cardápio</strong>
            <small>1 PDF até 10 MB ou até 10 fotos JPG, PNG ou WebP de 5 MB cada.</small>
          </div>
          <input #arquivosInput type="file" hidden multiple
                 accept="application/pdf,image/jpeg,image/png,image/webp"
                 (change)="selecioneArquivosCardapio($event)">
          <button type="button" class="cardapio-lab__escolher"
                  [disabled]="operandoCardapio" (click)="arquivosInput.click()">
            <i class="fas fa-paperclip" aria-hidden="true"></i>
            Escolher arquivos
          </button>
          <ul *ngIf="arquivosCardapio.length">
            <li *ngFor="let arquivo of arquivosCardapio">
              <span>{{ arquivo.name }}</span><small>{{ tamanhoLegivel(arquivo.size) }}</small>
            </li>
          </ul>
          <button type="button" class="cardapio-lab__analisar"
                  [disabled]="!arquivosCardapio.length || operandoCardapio"
                  (click)="envieEAnaliseCardapio()">
            <i class="fas" [class.fa-circle-notch]="operandoCardapio"
               [class.fa-spin]="operandoCardapio" [class.fa-magic]="!operandoCardapio"
               aria-hidden="true"></i>
            {{ operandoCardapio ? 'Analisando…' : 'Enviar e criar rascunho' }}
          </button>
        </div>

        <div class="cardapio-lab__mensagem" *ngIf="mensagemCardapio">
          <i class="fas fa-info-circle" aria-hidden="true"></i>{{ mensagemCardapio }}
        </div>

        <div class="cardapio-lab__resumo" *ngIf="analiseCardapio?.estatisticas as estatisticas">
          <span><strong>{{ estatisticas.categorias }}</strong><small>categorias</small></span>
          <span><strong>{{ estatisticas.produtos }}</strong><small>produtos</small></span>
          <span><strong>{{ estatisticas.adicionais }}</strong><small>adicionais</small></span>
          <span><strong>{{ estatisticas.opcoes }}</strong><small>opções</small></span>
          <span [class.cardapio-lab__resumo-alerta]="estatisticas.pendenciasBloqueantes">
            <strong>{{ estatisticas.pendenciasBloqueantes }}</strong><small>bloqueios</small>
          </span>
        </div>

        <div class="cardapio-lab__resultado" *ngIf="analiseCardapio?.resultado as resultado">
          <strong>{{ resultado.conclusao === 'CONCLUIDA' ? 'Importação concluída' : 'Importação parcial' }}</strong>
          <span>{{ resultado.importados?.length || 0 }} novos · {{ resultado.reutilizados?.length || 0 }} já existentes ·
            {{ resultado.falhas?.length || 0 }} falhas</span>
          <ul *ngIf="resultado.falhas?.length">
            <li *ngFor="let falha of resultado.falhas"><b>{{ falha.referencia }}</b> {{ falha.mensagem }}</li>
          </ul>
          <ul *ngIf="resultado.requerConciliacao?.length">
            <li *ngFor="let referencia of resultado.requerConciliacao">
              <b>{{ referencia }}</b> requer conferência manual antes de uma nova tentativa.
            </li>
          </ul>
        </div>

        <div class="rascunho" *ngIf="analiseCardapio?.rascunho as rascunho">
          <header class="rascunho__topo">
            <div>
              <strong>Revisão humana obrigatória</strong>
              <small>{{ referenciasSelecionadas.length }} de {{ totalProdutosRascunho }} produto(s) selecionado(s)</small>
            </div>
            <span>
              <button type="button" (click)="alterneTodosProdutos(true)" [disabled]="!podeRevisarCardapio">Todos</button>
              <button type="button" (click)="alterneTodosProdutos(false)" [disabled]="!podeRevisarCardapio">Nenhum</button>
            </span>
          </header>

          <article class="categoria-rascunho" *ngFor="let categoria of rascunho.categorias; let ci = index">
            <label>
              <small>CATEGORIA {{ ci + 1 }}</small>
              <input [(ngModel)]="categoria.nome" [name]="'categoria-' + categoria.referencia"
                     maxlength="160"
                     [disabled]="!podeRevisarCardapio || categoriaTemProdutoImportado(categoria)">
            </label>

            <div class="produto-rascunho" *ngFor="let produto of categoria.produtos">
              <div class="produto-rascunho__selecao">
                <input type="checkbox" [(ngModel)]="produto.selecionado"
                       [name]="'selecionado-' + produto.referencia" [disabled]="!podeRevisarCardapio">
                <span><strong>{{ produto.referencia }}</strong><small *ngIf="produtoJaImportado(produto.referencia)">JÁ IMPORTADO</small></span>
              </div>
              <div class="produto-rascunho__campos">
                <label>Nome
                  <input [(ngModel)]="produto.nome" [name]="'produto-' + produto.referencia"
                         maxlength="160" [disabled]="!podeRevisarCardapio || produtoJaImportado(produto.referencia)">
                </label>
                <label>Preço
                  <input type="number" min="0" step="0.01" [(ngModel)]="produto.preco"
                         [name]="'preco-' + produto.referencia"
                         [disabled]="!podeRevisarCardapio || produtoJaImportado(produto.referencia)">
                </label>
                <label class="produto-rascunho__descricao">Descrição
                  <textarea rows="2" maxlength="2000" [(ngModel)]="produto.descricao"
                            [name]="'descricao-' + produto.referencia"
                            [disabled]="!podeRevisarCardapio || produtoJaImportado(produto.referencia)"></textarea>
                </label>
              </div>

              <details class="adicionais-rascunho" *ngIf="produto.adicionais?.length">
                <summary>{{ produto.adicionais.length }} grupo(s) de adicionais / tamanhos</summary>
                <div class="adicional-rascunho" *ngFor="let adicional of produto.adicionais">
                  <label>Grupo
                    <input [(ngModel)]="adicional.nome" [name]="'adicional-' + adicional.referencia"
                           maxlength="160" [disabled]="!podeRevisarCardapio || produtoJaImportado(produto.referencia)">
                  </label>
                  <span>{{ adicional.tipoSelecao || 'tipo pendente' }} · mín. {{ adicional.minimo }} · máx. {{ adicional.maximo }}</span>
                  <div class="opcao-rascunho" *ngFor="let opcao of adicional.opcoes">
                    <input [(ngModel)]="opcao.nome" [name]="'opcao-' + opcao.referencia"
                           maxlength="160" [disabled]="!podeRevisarCardapio || produtoJaImportado(produto.referencia)">
                    <input type="number" min="0" step="0.01" [(ngModel)]="opcao.preco"
                           [name]="'opcao-preco-' + opcao.referencia"
                           [disabled]="!podeRevisarCardapio || produtoJaImportado(produto.referencia)">
                  </div>
                </div>
              </details>
            </div>
          </article>

          <div class="rascunho__acoes" *ngIf="podeRevisarCardapio">
            <button type="button" class="rascunho__salvar" [disabled]="operandoCardapio"
                    (click)="salveRascunhoCardapio()">Salvar revisão</button>
            <button type="button" class="rascunho__preparar"
                    [disabled]="operandoCardapio || !referenciasSelecionadas.length"
                    (click)="prepareImportacaoCardapio()">
              {{ operandoCardapio ? 'Preparando…' : 'Preparar importação' }}
            </button>
          </div>
          <small class="rascunho__nota">Salvar só versiona o rascunho. Preparar cria um preview; importar exige a aprovação separada.</small>
        </div>
      </section>

      <section class="acao-pendente" *ngIf="acaoPendente">
        <div class="acao-pendente__cabecalho">
          <span class="gestor__etiqueta">APROVAÇÃO NECESSÁRIA · {{ acaoPendente.risco }}</span>
          <strong>{{ tituloDaAcao }}</strong>
        </div>
        <p>{{ acaoPendente.impacto }}</p>
        <dl class="acao-pendente__empresa" *ngIf="previewEmpresa; else previewGenerico">
          <div class="acao-pendente__empresa-destaque">
            <dt>Empresa</dt><dd>{{ previewEmpresa.nome }}</dd>
          </div>
          <div><dt>Subdomínio</dt><dd>{{ previewEmpresa.subdominio }}</dd></div>
          <div><dt>Responsável</dt><dd>{{ previewEmpresa.responsavel.nome }}</dd></div>
          <div *ngIf="previewEmpresa.responsavel.email"><dt>E-mail</dt><dd>{{ previewEmpresa.responsavel.email }}</dd></div>
          <div *ngIf="previewEmpresa.whatsapp"><dt>WhatsApp</dt><dd>{{ previewEmpresa.whatsapp }}</dd></div>
          <div *ngIf="previewEmpresa.endereco"><dt>Endereço</dt><dd>{{ previewEmpresa.endereco }}</dd></div>
          <div *ngIf="previewEmpresa.cep"><dt>CEP</dt><dd>{{ previewEmpresa.cep }}</dd></div>
        </dl>
        <ng-template #previewGenerico><pre>{{ resumoDaAcao }}</pre></ng-template>
        <small>Preview imutável · hash {{ acaoPendente.hashPreview | slice:0:12 }}… · versão {{ versao }}</small>
        <div class="acao-pendente__botoes">
          <button type="button" class="acao-pendente__cancelar"
                  [disabled]="operandoAcao" (click)="canceleAcao()">Cancelar</button>
          <button type="button" class="acao-pendente__aprovar"
                  [disabled]="operandoAcao" (click)="aproveAcao()">
            {{ operandoAcao ? 'Processando…' : 'Aprovar e executar' }}
          </button>
        </div>
      </section>

      <form class="conversa__entrada" (ngSubmit)="envie()">
        <label for="mensagem-gestor">Fale com a MIA Gestor</label>
        <div class="conversa__campo">
          <textarea #campoMensagem
                    id="mensagem-gestor"
                    name="mensagemGestor"
                    [(ngModel)]="mensagem"
                    (keydown)="aoPressionarTecla($event)"
                    maxlength="4000"
                    rows="2"
                    [placeholder]="modoSimulador ? 'Escreva uma mensagem para testar…' : 'Conte os dados da empresa ou pergunte o que falta…'"
                    [disabled]="enviando || carregandoOnboarding || !onboardingId"></textarea>
          <button type="submit" [disabled]="!mensagem.trim() || enviando || carregandoOnboarding || !onboardingId">
            <span>Enviar</span>
            <i class="fas fa-arrow-up" aria-hidden="true"></i>
          </button>
        </div>
        <div class="conversa__entrada-rodape">
          <small>A conversa fica registrada. Aprovações continuam separadas e seguras.</small>
          <span><kbd>Enter</kbd> envia · <kbd>Shift + Enter</kbd> quebra a linha</span>
        </div>
      </form>
    </article>
  </section>
</main>
